import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Modal, Select, Spin, Table } from 'antd';
import { DownloadPdfWorkOrder, TableDataDays, TableDataDaysExport, TableDataDaysExportLocomotive, TableDataDaysLocomotive, TableWoDelete } from '../../Services/employee';
import { useHistory } from 'react-router';
import { EditOutlined } from '@ant-design/icons';
const ModalDeleteWoTableLocomotive = ({ showModal, handleOk, handleCancel, isModalOpen, apiData }) => {


    const dropdownOptions = [
        { key: '7', label: 'Last 7 Days' },
        { key: '14', label: 'Last 14 Days' },
        { key: '30', label: 'Last 30 Days' },
        { key: '90', label: 'Last 90 Days' },
        { key: '0', label: 'All' }
    ];

    const { Option } = Select;
    const history = useHistory()
    const { location } = history
    const [data, setData] = useState();
    const [form] = Form.useForm()

    const id = location?.state?.id;
    const [isModalOpenPart, setIsModalOpenPart] = useState(false);
    const [filterDuration, setFilterDuration] = useState(dropdownOptions[0]?.key); // Set initial value here
    const [filteredData, setFilteredData] = useState([]);
    const [showExportButton, setShowExportButton] = useState(false);
    const [currIndex, setCurrIndex] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [SelectedFilterValue, setSelectedFilterValue] = useState('7')
    const [pageSize, setPageSize] = useState();

    const showModalPart = (index) => {
        setCurrIndex(index)
        setIsModalOpenPart(true);
    };
    const handleOkPart = () => {
        setIsModalOpenPart(false);
    };
    const handleCancelPart = () => {
        setIsModalOpenPart(false);
    };

     
    const contractormap = (data) => {
        if (data) {
            let {
                firstName,
                lastName,
                Company
            } = data;

            let output = '';

            if (Company)
                output = Company;

            if (Company && firstName && lastName)
                output = output + "-"

            if (firstName && lastName)
                output = `${output} ${firstName} ${lastName[0]}.`

            return output;
        }

        return ''

    };

    const handleFilter = async (value) => {
        setFilterDuration(value)
        setSelectedFilterValue(value)

        try {

            const response = await TableDataDaysLocomotive({ days: value });
            setData(response?.data);
            setShowExportButton(response?.data?.length > 0);

        } catch (error) {

            console.error('Error fetching data:', error);
        }
    };

    const hitAPIWithDefault7 = async () => {
        const response = await TableDataDaysLocomotive({ days: 7 });
        setData(response?.data);
        setShowExportButton(response?.data?.length > 0);

    }


    const handleExportDeleteTask = async (value) => {

        setFilterDuration(value);
        try {
            // Include the days value in the payload
            const payload = {
                days: filterDuration,
            };
            const response = await TableDataDaysExportLocomotive({ days: SelectedFilterValue });
            const blob = new Blob([response], { type: 'application/csv' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `DeleteTableSheet.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data:', error);
        }

    };
    const handleNavigation = (id) => {



        history.push(`/Locomotive-work-order-edit`, { id })

    }


    useEffect(() => {
        // Check the length of the initial data and update state accordingly
        setShowExportButton(data?.length > 0);
        hitAPIWithDefault7()
        setCurrentPage(1);
        setPageSize(10);

    }, []);

    const columns = [
        {
            title: 'WO_ID',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, item) => {
                return <a onClick={() => handleNavigation(record?.WO_ID)}>{record?.WO_ID}</a>;
            },
        },
        {
            title: 'Category',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.EquipWOTaskDD?.EquipWOSubCategory?.EquipWOCategory?.Category}</p>;
            },
        },
        {
            title: 'Sub Category',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.EquipWOTaskDD?.EquipWOSubCategory?.SubCategory}</p>;
            },
        },
        {
            title: 'Task',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.EquipWOTaskDD?.Task}</p>;
            },
        },
        {
            title: 'Position',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.Position || 'N/A'}</p>;
            },
        },
        {
            title: 'Part',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => {
                return <Button onClick={() => showModalPart(index)}> <EditOutlined /> </Button>;
            },
        },
        {
            title: 'Assigned To	',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return (
                    <p>

                        {/* {record?.AssignedTo?.firstName && record?.AssignedTo?.lastName
                            ? `${record.AssignedTo.firstName} ${record.AssignedTo.lastName}`
                            : record?.AssignedtoContractor?.firstName && record?.AssignedtoContractor?.lastName  // Fix the typo here
                                ? `${record?.AssignedtoContractor?.firstName} ${record?.AssignedtoContractor?.lastName}`
                                : 'N/A'} */}
                        {record?.AssignedTo?.firstName && record?.AssignedTo?.lastName
                            ? `${record.AssignedTo.firstName} ${record.AssignedTo.lastName}`
                            : record?.AssignedtoContractor
                                ? `${contractormap(record?.AssignedtoContractor)}`
                                : 'N/A'}
                    </p>
                );
            },
        },
        //     render: (text, record) => {
        //         return <p>
        //             {record?.AssignedTo?.firstName && record?.AssignedTo?.lastName
        //                 ? `${record.AssignedTo.firstName} ${record.AssignedTo.lastName}`
        //                 : record?.AssignedtoContractor?.firstName && record?.AssignedtoContractor?.LastName
        //                     ? `${record?.AssignedtoContractor?.firstName} ${record?.AssignedtoContractor?.LastName}`
        //                     : 'N/A'}
        //         </p>;
        //     },
        // },
        {
            title: 'Status',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.Status}</p>;
            },
        },
        {
            title: 'Deleted By',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>
                    {record?.DeletedBy
                        ? `${record.DeletedBy.firstName} ${record.DeletedBy.lastName}`
                        : "N/A"}
                </p>
            },
        },
        {
            title: 'Notes',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.Notes || 'N/A'}</p>;
            },
        },


    ];

    const onCancel = () => {

        setSelectedFilterValue('7')
        setCurrentPage(1);
        setFilterDuration(null)

        setTimeout(() => {
            handleCancel()
            handleFilter()
            setFilterDuration(dropdownOptions[0]?.key)
            setPageSize(10);

        }, 20);
    }
    const handlePageSizeChange = (current, newSize) => {
        setCurrentPage(1); // Reset to the first page when pageSize changes
        setPageSize(newSize); // Assuming you have a state variable for pageSize
    };

    return (
        <div >
            <Modal className='modalWidth'
                title={

                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Deleted Task</span>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {showExportButton > 0 && (

                                    <Button onClick={handleExportDeleteTask}
                                        // disabled={!showExportButton} 
                                        style={{ marginRight: '10px', background: '#2863ad', color: "white", borderRadius: '10px' }}
                                    >Export Deleted Tasks</Button>
                                )}

                                {filterDuration && <Select defaultValue={SelectedFilterValue || dropdownOptions[0]} style={{ width: '130px', marginRight: '20px' }} onChange={handleFilter}>
                                    {dropdownOptions.map(option => (
                                        <Option key={option.key} value={option.key}>{option.label}</Option>
                                    ))}
                                </Select>}
                            </div>
                        </div>
                    </div>

                }
                open={isModalOpen} onOk={handleOk} onCancel={onCancel} footer={null} >
                <Table columns={columns} dataSource={data} style={{ zoom: '0.7' }} scroll={{ x: true }}
                    // pagination={{
                    //     current: currentPage,
                    //     pageSize: 10, // Set the pageSize to the desired value
                    //     total: data?.length,
                    //     onChange: (page) => setCurrentPage(page),
                    // }} />
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: data?.length,
                        onChange: (page) => setCurrentPage(page),
                        onShowSizeChange: handlePageSizeChange, // Add this to handle pageSize changes
                    }} 
                    />
            </Modal>
            <Modal
                title={
                    <span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Part Info</span>
                }
                open={isModalOpenPart} onOk={handleOkPart} onCancel={handleCancelPart}
                footer={null}>

                <Form
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    style={{
                        maxWidth: 600,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    labelAlign='left'

                >
                    <Form.Item
                        label={<span style={{ fontWeight: 'bold' }}>Part Type</span>}
                        name="partType"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your username!',
                            },
                        ]}
                    >
                        {data?.length && data[currIndex]?.PartType !== ""
                            ? data[currIndex]?.PartType
                            : 'N/A'}
                        {/* { } */}
                        {/* <Input /> */}
                    </Form.Item>
                    <Form.Item
                        label={<span style={{ fontWeight: 'bold' }}>Part Number</span>}

                        name="partNumber"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your username!',
                            },
                        ]}
                    >
                        {data?.length && data[currIndex]?.PartNbr !== "" || null
                            ? data[currIndex]?.PartNbr
                            : 'N/A'}
                    </Form.Item>
                    <Form.Item
                        label={<span style={{ fontWeight: 'bold' }}>Part Serial Number</span>}

                        name="partSerialNumber"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your username!',
                            },
                        ]}
                    >


                        { }
                        {data?.length && data[currIndex]?.PartSerialNbr !== "" || null
                            ? data[currIndex]?.PartSerialNbr
                            : 'N/A'}
                        {/* {data?.length ? data[currIndex]?.PartSerialNbr : 'N/A'} */}
                    </Form.Item>



                </Form>
            </Modal>
        </div>
    );
};
export default ModalDeleteWoTableLocomotive;